import { ReactNode } from "react"

interface TableBodyProps {
  children: ReactNode
}

export const TableBody = ({ children }: TableBodyProps) => <tbody>{children}</tbody>
